import React from "react";
import {FeedbackOnlyText} from "../../../../../components/FeedbackOnlyText";

import { observer } from "mobx-react-lite";
import { ReactComponent as AttentionIcon } from "../../../../../assets/icons/attention.svg";
import { useNavigateCustom } from "../../../../../hooks";

const feedbackText = {
	title: "Sua proposta expirou",
	description:
          "Você pode solicitar uma nova análise de crédito agora ou fazer isso mais tarde",
	type: "expiredDeal",
	link: {},
	warnings: [],
	button: {
		primaryButtonText: "Solicitar nova análise",
		secondaryButtonText: "Ir pro início",
	},
};

export const ExpiredDealFeedback: React.FC = observer(() => {
	const navigate = useNavigateCustom();

	return (
		<FeedbackOnlyText
			styleProps={{marginTop: "80px"}}
			data={feedbackText}
			primaryButton={{
				title: feedbackText.button.primaryButtonText,
				onClick: () => navigate("/emprestimo-simulacao", { replace: true }),
			}}
			secondaryButton={{
				title: feedbackText.button.secondaryButtonText,
				onClick: () => navigate("/", { replace: true }),
				variant: "ghost",
			}}
			icon={{
				icon: AttentionIcon,
				w: 58,
				color: "error",
			}}
		/>
	);
});
